import { Button, CircularProgress } from "@mui/material"
import LaudoVisita from "entity/LaudoVisita"
import { isFormFilled } from "../functions"
import { useEffect } from "react"
import useNotification from "notification"

export default function FilterButton({ filters, setMsgFilter, setLaudos, filtersOld, setFiltersOld, globalLoading, setGlobalLoading }) {
    const { showWarning } = useNotification()

    const filterOnClick = async () => {
        const validObj = async (laudo) => {
            let entity = new LaudoVisita()
            entity.update(laudo)

            return entity.data
        }

        let observer = null
        if (filters.cliente && filters.dataInicio && filters.dataFim) {
            setMsgFilter("")
            setGlobalLoading("Buscando Laudos")
            let query = LaudoVisita.collection
            query = query.where('cliente.uid', '==', filters.cliente.uid)
            query = query.where("dataStr", ">=", filters.dataInicio.replaceAll("-", ""))
            query = query.where("dataStr", "<=", filters.dataFim.replaceAll("-", ""))
            observer = query.onSnapshot(
                async (qs) => {
                    let l = []
                    if (!qs.empty) {
                        for (let i = 0; i < qs.docs.length; i++) {
                            const doc = qs.docs[i]

                            let laudo = await validObj(doc.data())
                            if (laudo)
                                l.push(laudo)
                        }
                    }
                    console.log('return laudos', l.length)
                    setLaudos(l)
                    setGlobalLoading("")
                    if (l.length === 0) {
                        showWarning("Nenhum Laudo")
                    }
                },
                (err) => {
                    console.error(`error: ${err}`)
                }
            )
        } else {
            if (isFormFilled(filters, setMsgFilter)) {
                console.log('Tudo OK!')
            } else {
                console.log('Faltou preencher algum campo...')
            }
            setGlobalLoading("")
        }

        return () => {
            if (observer) observer()
        }
    }

    useEffect(() => {
        if (!isFormFilled(filters, setMsgFilter)) {
            return
        }
        setGlobalLoading("")

        if (filters.cliente !== filtersOld.cliente) {
            filterOnClick()
        } else {
            setMsgFilter("Clique no botão filtrar p/ atualizar o resultado")
        }
        setFiltersOld(filters)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.cliente,
        filters.dataInicio,
        filters.dataFim,
    ])

    useEffect(() => {
        setLaudos([])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Button style={{ whiteSpace: 'noWrap', minWidth: 'auto', }} onClick={filterOnClick} disabled={globalLoading.length ? true : false}>
            {globalLoading.length ? <CircularProgress /> : 'Filtrar'}
        </Button>
    )
}